import { facadeApi } from 'api'

export const deleteGroupApi = (id: string) => facadeApi.delete(`/az/groups/${id}`)
